import React, { useEffect, useState } from 'react';
import { Suspense } from 'react';
import Layout from './components/layout/Layout.jsx';
import { PublicRoutes } from './routes/PublicRoute.js';
import '../src/assets/css/style.css';
import PrivateRoutes from './routes/PrivateRoute.js';
import { useMsal } from '@azure/msal-react';
import { jwtDecode } from 'jwt-decode';
import { useDispatch, useSelector } from 'react-redux';
import { setUsername } from './redux/reducers/userReducer.js';
import { BrandManager } from './utils/api/bm.api.js';

const brandManager = new BrandManager();
function App() {
  const dispatch = useDispatch();
  const { accounts, inProgress, instance } = useMsal();
  const isAuthenticated = accounts.length > 0;
  const { bm_detail } = useSelector((state) => state.user);
  const [userDetailsSaved, setUserDetailsSaved] = useState(false);

  useEffect(() => {
    const checkTokenValidity = () => {
      const token = localStorage.getItem('accessToken');
      if (!token || isTokenExpired(token)) {
        initiateLogin();
      }
    };

    const isTokenExpired = (token) => {
      const decodedToken = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      return decodedToken.exp < currentTime;
    };

    const initiateLogin = () => {
      if (inProgress === 'none') {
        instance.loginRedirect();
      }
    };

    if (!isAuthenticated && inProgress === 'none') {
      initiateLogin();
    } else if (isAuthenticated) {
      const token = accounts[0].idToken;
      if (!token || isTokenExpired(token)) {
        return initiateLogin();
      }
      const decodedToken = jwtDecode(token);
      const { preferred_username: email, name } = decodedToken;
      dispatch(setUsername({ email, name }));
      localStorage.setItem('accessToken', JSON.stringify(token));
    }
  }, [isAuthenticated, inProgress, dispatch, instance, accounts]);

  useEffect(() => {
    const { name, email } = bm_detail;
    if (name && email && !userDetailsSaved) {
      brandManager.saveUserDetail({ name, email });
      setUserDetailsSaved(true);
    }
  }, [bm_detail, userDetailsSaved]);

  return (
    <div className="pageWrapper">
      <Suspense fallback={<div className="container">Loading...</div>}>
        <Layout>
          <PublicRoutes />
          <PrivateRoutes />
        </Layout>
      </Suspense>
    </div>
  );
}

export default App;
